import React, { createRef } from 'react';
import jwt_decode from 'jwt-decode';
import gearimg from "../../images/report/gear.png";
import ExpColimg from "../../images/report/expColReport.png";
import saveimg from "../../images/report/save.png";
import xlsimg from "../../images/report/xls.png";
import backimg from "../../images/report/back.png";
import PivotGridDataSource from 'devextreme/ui/pivot_grid/data_source';
import { LoadPanel } from 'devextreme-react/load-panel';
import { ToastContainer, toast } from 'react-toastify';
import apiClient from '../../utils/apiClient';
import PivotGrid, {
  FieldChooser, FieldPanel, Scrolling, Export
} from 'devextreme-react/pivot-grid';
import { Workbook } from 'exceljs';
import saveAs from 'file-saver';
import { exportPivotGrid } from 'devextreme/excel_exporter';
import { config } from "../../constants";
import ReportModal from "./ReportModal";
import SaveReportModal from "./SaveReportModal";
import checkSessionStatus from '../../utils/checkSessionStatus';

const url = config.url.URL;

const ListLoadUrl = `${url}/CriteriasMicroservice/Criteria`;
const MeasureLoadUrl = `${url}/CriteriasMicroservice/Measure`;
const CurrencyLoadUrl = `${url}/CriteriasMicroservice/Currency`;
var RepName = "";

var columns = null;
var rows = null;

class App extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      GriddataSource: null,
      ReportData: null,
      ReportName: "",
      ReportType: "",
      CriteriaValues: [],
      ListRowSelected: [],
      ListColumnSelected: [],
      MeasuresList: [],
      CurrenciesList: [],
      loadPanelVisible: true,
      showGrandTotals: true,
      btnExpColCol: true,
      btnExpColRow: true,
      btnExpColAll: true
    }

    this.pivotGrid = createRef();
  }

  componentDidMount() {

    // Check session status on initial load
    if (!checkSessionStatus()) {
      return;
    }

    const decoded = jwt_decode(localStorage.getItem('token'));
    this.setState({
      can_save_reports: decoded.can_save_reports === "true",
      can_share_reports: decoded.can_share_reports === "true",
      can_export_to_excel: decoded.can_export_to_excel === "true"
    });

    const { state } = this.props.location;

    this.pivotGrid.current.instance.bindChart(this.chart, {
      dataFieldsDisplayMode: 'splitPanes',
      alternateDataFields: false,
    });

    apiClient.get(ListLoadUrl)
      .then((response) => {
        const data = response.data;
        let values = data.map((item) => {
          return {
            label: item.name,
            value: item.criteriaId
          };
        });
        this.state.CriteriaValues = values;
      });

    apiClient.get(MeasureLoadUrl)
      .then((response) => {
        const data = response.data;
        this.state.MeasuresList = data;
        this.setState({
          MeasuresList: data
        });
      });

    apiClient.get(CurrencyLoadUrl)
      .then((response) => {
        const data = response.data;
        this.state.CurrenciesList = data;
        this.setState({
          CurrenciesList: data
        });
      });

    apiClient.get(`${url}/GeneratedReportMicroservice/GetGeneratedReport/${state.reportId}`)
      .then((response) => {
        const data = response.data;
        this.setState({ ReportData: JSON.parse(data) })
      });

    this.prepareGriddataSource();

    var ele = document.getElementsByClassName('dx-pivotgrid-export-button')[0];
    ele.style.display = 'none';
  }

  prepareGriddataSource = () => {

    document.getElementById('divExpCol').style.display = 'none';
    document.getElementById('lblColRow').style.display = 'none';
    document.getElementById('lblColCol').style.display = 'none';
    document.getElementById('lblColAll').style.display = 'none';

    if (this.state.ReportData != null) {

      const { state } = this.props.location;

      var arrDataField = {
        "Media type": "MediaType", "Year": "CalendarYearName", "Quarter": "QuarterName", "Objective": "ObjectiveName", "Agency": "BuyingAgencyName", "Sub-zone": "Subzone", "Zone": "Zone",
        "Sampling": "SamplingName", "SubMedia": "SubMediaName", "Month": "CalendarMonthName", "MonthNumber": "CalendarMonthOrder", "Maison": "Maison", "Position": "PositionName", "Country/Region": "Country", "Currency": "CurrencyCode",
        "Media": "MediaName", "Airport name": "AirportName", "Semester": "SemesterName", "Vehicle": "VehicleName", "Position type": "PositionCategoryName", "Division": "Division",
        "Publisher/Vendor": "PublisherName", "Agency network": "BuyingAgencyNetworkName"
      };

      let fieldsList = [];

      apiClient.get(`${url}/ReportMicroservice/${state.reportId}`)
        .then(response => {
          const data = response.data;
          if (JSON.parse(data.config).RowIdList != []) {
            const filtered = this.state.CriteriaValues.filter(obj => {
              return JSON.parse(data.config).RowIdList.includes(obj.value);
            });
            var sortingArr = JSON.parse(data.config).RowIdList;
            this.setState({
              ListRowSelected: filtered.slice().sort((a, b) => sortingArr.indexOf(a.value) - sortingArr.indexOf(b.value))
            })
          }
          for (let i = 0; i < this.state.ListRowSelected.length; i++) {
            var obj = this.state.ListRowSelected[i];
            let cri;
            if (obj.label === "Month") {
              cri = {
                caption: obj.label,
                dataField: arrDataField[obj.label],
                area: 'row',
                sortingMethod: (a, b) => {
                  const monthOrderA = this.state.ReportData.find(item => item.CalendarMonthName === a.value).CalendarMonthOrder;
                  const monthOrderB = this.state.ReportData.find(item => item.CalendarMonthName === b.value).CalendarMonthOrder;
                  return monthOrderA - monthOrderB;
                }
              }
            } else {
              cri = {
                caption: obj.label,
                dataField: arrDataField[obj.label],
                area: 'row',
                sortOrder: 'asc',
              };
            }
            fieldsList.push(cri);
          }

          if (JSON.parse(data.config).ColumnIdList != []) {
            const filtered = this.state.CriteriaValues.filter(obj => {
              return JSON.parse(data.config).ColumnIdList.includes(obj.value);
            });
            sortingArr = JSON.parse(data.config).ColumnIdList;
            this.setState({
              ListColumnSelected: filtered.slice().sort((a, b) => sortingArr.indexOf(a.value) - sortingArr.indexOf(b.value))
            })
          }
          for (let i = 0; i < this.state.ListColumnSelected.length; i++) {
            var obj = this.state.ListColumnSelected[i];
            let cri;
            if (obj.label === "Month") {
              cri = {
                caption: obj.label,
                dataField: arrDataField[obj.label],
                area: 'column',
                sortingMethod: (a, b) => {
                  const monthOrderA = this.state.ReportData.find(item => item.CalendarMonthName === a.value).CalendarMonthOrder;
                  const monthOrderB = this.state.ReportData.find(item => item.CalendarMonthName === b.value).CalendarMonthOrder;
                  return monthOrderA - monthOrderB;
                }
              }
            } else {
              cri = {
                caption: obj.label,
                dataField: arrDataField[obj.label],
                area: 'column'
              };
            }
            fieldsList.push(cri);
          }

          const currencyConfig = JSON.parse(data.config);
          const currencyList = currencyConfig.CurrencyIdList.map(id =>
            this.state.CurrenciesList.find(obj => obj.currencyId == id)?.name
          );

          const isLocalCurrencySelected = currencyList.includes("LCL");
          const uniqueCurrencies = new Set(this.state.ReportData.map(item => item.CurrencyCode));
          let multipleCurrencies = (currencyList.length > 1 || uniqueCurrencies.size > 1);

          //Always add the Currency or Target Currency column in the first position of the columns.
          if (isLocalCurrencySelected) {
            fieldsList.push({
              caption: 'Currency',
              dataField: 'CurrencyCode',
              dataType: 'string',
              area: 'column',
              showTotals: true
            });
          }
          else {
            fieldsList.push({
              caption: 'Currency',
              dataField: 'TargetCurrency',
              dataType: 'string',
              area: 'column',
              showTotals: true
            });
          }
          this.state.showGrandTotals = !multipleCurrencies;
          var CostIdListLenght = JSON.parse(data.config).CostIdList.length;
          for (let i = 0; i < CostIdListLenght; i++) {
            var checkedValue = this.state.MeasuresList.filter(obj => obj.measureId == JSON.parse(data.config).CostIdList[i])[0].name;

            if (checkedValue == "Net") {
              let cri = { caption: 'Net', dataField: 'Net', dataType: 'number', summaryType: 'sum', format: '0##,###,###.##', area: 'data' };
              fieldsList.push(cri);
            }
            if (checkedValue == "Technical Cost") {
              let cri = { caption: 'Technical Cost', dataField: 'TechnicalCost', dataType: 'number', summaryType: 'sum', format: '0##,###,###.##', area: 'data' };
              fieldsList.push(cri);
            }
            if (checkedValue == "Fees") {
              let cri = { caption: 'Fees', dataField: 'Fees', dataType: 'number', summaryType: 'sum', format: '0##,###,###.##', area: 'data' };
              fieldsList.push(cri);
            }
            if (checkedValue == "Final Cost") {
              let cri = { caption: 'Final Cost', dataField: 'FinalCost', dataType: 'number', summaryType: 'sum', format: '0##,###,###.##', area: 'data' };
              fieldsList.push(cri);
            }
          }

          var MeasureIdListLenght = JSON.parse(data.config).MeasureIdList ? JSON.parse(data.config).MeasureIdList.length : 0;
          for (let i = 0; i < MeasureIdListLenght; i++) {
            var checkedValue = this.state.MeasuresList.filter(obj => obj.measureId == JSON.parse(data.config).MeasureIdList[i])[0].name;
            if (checkedValue == "Units") {
              let cri = { caption: 'Units', dataField: 'Units', dataType: 'number', summaryType: 'sum', format: '0##,###,###.##', area: 'data' };
              fieldsList.push(cri);
            }
          }
          let orderedFieldsList;
          if (!multipleCurrencies) orderedFieldsList = this.reorderFields(fieldsList); else orderedFieldsList = fieldsList;
          this.setState({ GriddataSource: new PivotGridDataSource({ fields: this.reorderFields(fieldsList), store: this.state.ReportData }) });
          this.setState({ ReportName: data.name, ReportType: data.reportType });

          if (state.download == true) {
            this.gotoDownloadReport();
          }

          setTimeout(() => {

            columns = this.state.GriddataSource._data.columns;
            rows = this.state.GriddataSource._data.rows;
            const NestedRowCount = fieldsList.filter(arr => {
              if (arr.area == 'row') {
                return true;
              }
              return false;
            }).length;

            if (NestedRowCount > 1) {
              this.setState({ btnExpColRow: false })
            } else {
              document.getElementById('lblExpRow').style.color = 'lightslategray';
              document.getElementById('lblColRow').style.color = 'lightslategray';
            }

            const NestedColumnCount = fieldsList.filter(arr => {
              if (arr.area == 'column') {
                return true;
              }
              return false;
            }).length;

            if (NestedColumnCount > 1) {
              this.setState({ btnExpColCol: false })
            } else {
              document.getElementById('lblExpCol').style.color = 'lightslategray';
              document.getElementById('lblColCol').style.color = 'lightslategray';
            }

            if (NestedRowCount <= 1 && NestedColumnCount <= 1) {
              this.setState({ btnExpColAll: true })
              document.getElementById('lblExpAll').style.color = 'lightslategray';
              document.getElementById('lblColAll').style.color = 'lightslategray';
            } else {
              this.setState({ btnExpColAll: false })
            }

            document.getElementById('divExpCol').style.display = 'block';
          });

          this.state.GriddataSource.load();
        });

      this.setState({ loadPanelVisible: false })
      toast.success('Report is generated');
    }
    else {
      setTimeout(this.prepareGriddataSource, 50);
    }
  }

  reorderFields = (fieldsList) => {
    // Séparer les champs Currency des autres
    let currencyFields = fieldsList.filter(field => field.caption === 'Currency');
    let otherFields = fieldsList.filter(field => field.caption !== 'Currency');

    // Réorganiser la liste : mettre Currency en premier
    return [...currencyFields, ...otherFields];
  };


  expandAllColumns = () => {
    const pivotInstance = this.pivotGrid.current?.instance;
    if (!pivotInstance) return;
  
    const fields = pivotInstance.getDataSource().fields();
    const columnFields = fields.filter(field => field.area === 'column');
  
    columnFields.forEach(field => {
      pivotInstance.getDataSource().expandAll(field.index);
    });
  
    document.getElementById('lblExpCol').style.display = 'none';
    document.getElementById('lblColCol').style.display = 'inline-block';
    document.getElementById('lblExpAll').style.display = 'none';
    document.getElementById('lblColAll').style.display = 'inline-block';
  }
  
  collapseAllColumns = () => {
    const pivotInstance = this.pivotGrid.current?.instance;
    if (!pivotInstance) return;
  
    const dataSource = pivotInstance.getDataSource();
    const columnFields = dataSource.fields().filter(field => field.area === 'column');
  
    columnFields.forEach(field => {
      dataSource.collapseAll(field.index); 
    });
  
    dataSource.load();

    document.getElementById('lblExpCol').style.display = 'inline-block';
    document.getElementById('lblColCol').style.display = 'none';
    document.getElementById('lblExpAll').style.display = 'inline-block';
    document.getElementById('lblColAll').style.display = 'none';
  };
  
  expandAllRows = () => {
    const pivotInstance = this.pivotGrid.current?.instance;
    if (!pivotInstance) return;
  
    const dataSource = pivotInstance.getDataSource();
    const rowFields = dataSource.fields().filter(field => field.area === 'row');
  
    rowFields.forEach(field => {
      dataSource.expandAll(field.index);
    });
  
    dataSource.load();
  
    // UI
    document.getElementById('lblExpRow').style.display = 'none';
    document.getElementById('lblColRow').style.display = 'inline-block';
    document.getElementById('lblExpAll').style.display = 'none';
    document.getElementById('lblColAll').style.display = 'inline-block';
  };
  
  collapseAllRows = () => {
    const pivotInstance = this.pivotGrid.current?.instance;
    if (!pivotInstance) return;
  
    const dataSource = pivotInstance.getDataSource();
    const rowFields = dataSource.fields().filter(field => field.area === 'row');
  
    rowFields.forEach(field => {
      dataSource.collapseAll(field.index);
    });
  
    dataSource.load();

    document.getElementById('lblExpRow').style.display = 'inline-block';
    document.getElementById('lblColRow').style.display = 'none';
    document.getElementById('lblExpAll').style.display = 'inline-block';
    document.getElementById('lblColAll').style.display = 'none';
  };
  
  expandAllColsRows = () => {
    this.expandAllColumns();
    this.expandAllRows();

  document.getElementById('lblExpCol').style.display = 'none';
  document.getElementById('lblColCol').style.display = 'inline-block';
  document.getElementById('lblExpRow').style.display = 'none';
  document.getElementById('lblColRow').style.display = 'inline-block';
  document.getElementById('lblExpAll').style.display = 'none';
  document.getElementById('lblColAll').style.display = 'inline-block';
  
  };

  collapseAllColsRows = () => {
    this.collapseAllColumns();
    this.collapseAllRows();

    document.getElementById('lblExpCol').style.display = 'inline-block';
    document.getElementById('lblColCol').style.display = 'none';
    document.getElementById('lblExpRow').style.display = 'inline-block';
    document.getElementById('lblColRow').style.display = 'none';
    document.getElementById('lblExpAll').style.display = 'inline-block';
    document.getElementById('lblColAll').style.display = 'none';

    /*
    document.getElementById('lblExpCol').style.display = 'none';
    document.getElementById('lblColCol').style.display = 'inline-block';
    document.getElementById('lblExpAll').style.display = 'none';
    document.getElementById('lblColAll').style.display = 'inline-block';

        document.getElementById('lblExpRow').style.display = 'inline-block';
    document.getElementById('lblColRow').style.display = 'none';
    document.getElementById('lblExpAll').style.display = 'inline-block';
    document.getElementById('lblColAll').style.display = 'none';
    */
  }
  
  gotoSettings = () => {
    const { state } = this.props.location;
    this.refs.repModal.openSettings(state.reportId);
  }

  gotoSaveAndShare = () => {
    const { state } = this.props.location;
    this.refs.saveRepModal.openSettingsShareModal(this.state.ReportName, this.state.ReportType, state.reportId);
  }

  gotoBackToReports = () => {
    this.props.history.push("/report");
  }

  gotoDownloadReport = () => {
    RepName = this.state.ReportName;
    let btn = document.querySelector("div.dx-pivotgrid-export-button");
    this.expandAllColsRows();
    this.simulateMouseClick(btn);
  }

  isDataCell = (cell) =>
    cell.area === 'data' && cell.rowType === 'D' && cell.columnType === 'D';
  isTotalCell = (cell) =>
    cell.type === 'T'
    || cell.type === 'GT'
    || cell.rowType === 'T'
    || cell.rowType === 'GT'
    || cell.columnType === 'T'
    || cell.columnType === 'GT';
  getExcelCellFormat = ({ fill, font, bold }) => ({
    fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: fill } },
    font: { color: { argb: font }, bold },
  });
  getCssStyles = ({ fill, font, bold }) => ({
    'background-color': `#${fill}`,
    color: `#${font}`,
    'font-weight': bold ? 'bold' : undefined,
  });
  getConditionalAppearance = (cell) => {
    if (this.isTotalCell(cell)) {
      return { fill: 'F2F2F2', font: '3F3F3F', bold: true };
    }
    const { value } = cell;
    return { font: '000000', fill: 'FFFFFF', bold: false };
  };

  onExporting = (e) => {
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet('Main sheet');

    exportPivotGrid({
      component: e.component,
      exportColumnFieldHeaders: true,
      exportDataFieldHeaders: true,
      exportFilterFieldHeaders: true,
      exportRowFieldHeaders: true,
      worksheet,
      customizeCell: ({ pivotCell, excelCell }) => {
        if (this.isDataCell(pivotCell) || this.isTotalCell(pivotCell)) {
          const appearance = this.getConditionalAppearance(pivotCell);
          Object.assign(excelCell, this.getExcelCellFormat(appearance));
        }}
    }).then(() => {
      workbook.xlsx.writeBuffer().then((buffer) => {
        saveAs(new Blob([buffer], { type: 'application/octet-stream' }), `${RepName}.xlsx`);
      });
    });
    e.cancel = true;
  }

  simulateMouseClick(el) {
    let opts = { view: window, bubbles: true, cancelable: true, buttons: 1 };
    el.dispatchEvent(new MouseEvent("mousedown", opts));
    new Promise(r => setTimeout(r, 50));
    el.dispatchEvent(new MouseEvent("mouseup", opts));
    el.dispatchEvent(new MouseEvent("click", opts));
  }

  render() {
    return (
      <div className="div-body-section-details view-report-grid-page">
        <div className="div-body-section-details-header">
          <div className="div-section-title">
            <span>{`Reports > ${this.state.ReportName}`}</span>
          </div>
          <div className="div-section-actions push">
            <button className="btn-section-header" onClick={this.gotoSettings}>
              <img className="img-section-header" src={gearimg} />
              <label>Report Settings</label>
            </button>&nbsp;
            <button className={this.state.can_save_reports && this.state.can_share_reports ? "btn-section-header" : "btn-section-header hidden"} onClick={this.gotoSaveAndShare}>
              <img className="img-section-header" src={saveimg} />
              <label>Save & Share Report</label>
            </button>&nbsp;
            <button className={this.state.can_export_to_excel ? "btn-section-header" : "btn-section-header hidden"} onClick={this.gotoDownloadReport}>
              <img className="img-section-header" src={xlsimg} />
              <label>Download Report</label>
            </button>&nbsp;
            <button className="btn-section-header" onClick={this.gotoBackToReports}>
              <img className="img-section-header" src={backimg} />
              <label>Back to Reports</label>
            </button>
          </div>
          <div id='divExpCol' style={{ position: 'absolute', width: '100%', marginTop: '46px', marginLeft: '-40px', zIndex: '100' }}>
            <button disabled={this.state.btnExpColRow} className={this.state.btnExpColRow ? 'btn-ColExpReport' : 'btn-ColExpReport btn-ColExpReportHover'} style={{ float: 'right' }}>
              <img className="img-ColExpsection-header" src={ExpColimg} />
              <label id='lblExpRow' style={{ cursor: this.state.btnExpColRow ? 'normal' : 'pointer' }} onClick={this.state.btnExpColRow ? null : this.expandAllRows}>Expand Rows</label>
              <label id='lblColRow' style={{ cursor: this.state.btnExpColRow ? 'normal' : 'pointer' }} onClick={this.state.btnExpColRow ? null : this.collapseAllRows}>Collapse Rows</label>
            </button>&nbsp;
            <button disabled={this.state.btnExpColCol} className={this.state.btnExpColCol ? 'btn-ColExpReport' : 'btn-ColExpReport btn-ColExpReportHover'} style={{ float: 'right' }}>
              <img className="img-ColExpsection-header" src={ExpColimg} />
              <label id='lblExpCol' style={{ cursor: this.state.btnExpColCol ? 'normal' : 'pointer' }} onClick={this.state.btnExpColCol ? null : this.expandAllColumns}>Expand Columns</label>
              <label id='lblColCol' style={{ cursor: this.state.btnExpColCol ? 'normal' : 'pointer' }} onClick={this.state.btnExpColCol ? null : this.collapseAllColumns}>Collapse Columns</label>
            </button>&nbsp;
            <button disabled={this.state.btnExpColAll} className={this.state.btnExpColAll ? 'btn-ColExpReport' : 'btn-ColExpReport btn-ColExpReportHover'} style={{ float: 'right' }}>
              <img className="img-ColExpsection-header" src={ExpColimg} />
              <label id='lblExpAll' style={{ cursor: this.state.btnExpColAll ? 'normal' : 'pointer' }} onClick={this.state.btnExpColAll ? null : this.expandAllColsRows}>Expand All</label>
              <label id='lblColAll' style={{ cursor: this.state.btnExpColAll ? 'normal' : 'pointer' }} onClick={this.state.btnExpColAll ? null : this.collapseAllColsRows}>Collapse All</label>
            </button>&nbsp;
          </div>
        </div>

        <LoadPanel
          visible={this.state.loadPanelVisible}
          showIndicator={true}
          shading={true}
          showPane={true}
          hideOnOutsideClick={false}
        />

        <React.Fragment>
          <PivotGrid
            id="pivotgrid"
            dataSource={this.state.GriddataSource}
            allowSorting={true}
            allowSortingBySummary={true}
            allowFiltering={true}
            showBorders={true}
            showColumnTotals={true}
            showColumnGrandTotals={this.state.showGrandTotals}
            showRowTotals={true}
            showRowGrandTotals={true}
            ref={this.pivotGrid}
            height="640"
            onExporting={this.onExporting}
            allowExpandAll={true}
            showTotalsPrior='rows'
          >
            <FieldPanel
              showColumnFields={true}
              showDataFields={true}
              showFilterFields={false}
              showRowFields={true}
              allowFieldDragging={false}
              visible={true}
            />
            <FieldChooser enabled={false} height={400} />
            <Scrolling mode="virtual" />
            <Export enabled={true} />
          </PivotGrid>
        </React.Fragment>

        <ReportModal ref="repModal"></ReportModal>
        <SaveReportModal ref="saveRepModal"></SaveReportModal>

        <ToastContainer position="bottom-right" />
      </div>
    );
  }
}

const currencyFormatter = new Intl.NumberFormat(
  'en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 0,
},
);

function customizeTooltip(args) {
  const valueText = currencyFormatter.format(args.originalValue);
  return {
    html: `${args.seriesName} | Total<div class="currency">${valueText}</div>`,
  };
}

export default App;
